export default "__VITE_ASSET__CzJIo96b__"